import type { OwaDate } from 'owa-datetime';
import { addDays, differenceInMinutes, startOfDay } from 'owa-datetime';
import isDSTTransitionDate from './isDSTTransitionDate';
import TimeConstants from './TimeConstants';

/**
 * Gets the actual number of minutes in a day, accounting for DST transitions.
 *
 * During DST transitions:
 * - Spring forward: Returns 1380 minutes (23 hours) when an hour is skipped
 * - Fall back: Returns 1500 minutes (25 hours) when an hour is repeated
 * - Normal days: Returns 1440 minutes (24 hours)
 *
 * @param date The date to check
 * @returns The actual number of minutes in that calendar day
 */
export default function getMinutesInDay(date: OwaDate): number {
    if (!isDSTTransitionDate(date)) {
        return TimeConstants.MinutesInOneDay;
    }

    // DST-aware: difference between start of day and next day
    return differenceInMinutes(addDays(startOfDay(date), 1), startOfDay(date));
}
